export enum ExamCategory {
	MONITORING_EXAM = 2,
	PRESENTIAL = 3,
	HOMEWORK = 4,
	HYBRID = 5,
}

export enum QuestionCategory {
	TEXTUAL = 0,
	CHOICE = 1,
	FILE = 2,
	SUM_QUESTION = 3,
}

export const QuestionCategoryAPI: Record<QuestionCategory, string> = {
	[QuestionCategory.CHOICE]: "option",
	[QuestionCategory.TEXTUAL]: "textual",
	[QuestionCategory.SUM_QUESTION]: "sum",
	[QuestionCategory.FILE]: "file",
};

export interface Alternative {
	id: string | number;
	text: string;
}

export interface BaseText {
	id: string | number;
	title: string;
	text: string;
}

export interface Question {
	id: string | number;
	enunciation: string;
	category: QuestionCategory;
	acceptsAudioResponse?: boolean;
	alternatives: Alternative[];
	baseTexts: BaseText[];
}

export interface ExamQuestion {
	id: string | number;
	number: number;
	question: Question;
	answer: {
		answerId?: string | null;
		text?: string | null;
		checkedOptions: (string | number)[];
		fileUrl?: string | null;
		answerMediaKind?: "audio" | "image" | null;
	};
}

export interface SubjectWithQuestions {
	id: string | number;
	name: string;
	examQuestions: ExamQuestion[];
}

export interface ApplicationExecution {
	id: string;
	application: {
		id: string;
		exam: {
			id: string;
			name: string;
			subjects: SubjectWithQuestions[];
			randomQuestions?: boolean;
			randomAlternatives?: boolean;
		};
		orientations: string | null;
		category: ExamCategory;
		date: string;
		start: string;
		end: string;
		dateTimeEndTz: string;
		maxTimeToFinish?: number;
		hasToken: boolean;
		/** Legado; o gate de token no app aluno usa apenas estado local após o POST. */
		hasTokenChecked?: boolean;
		canBeDoneCell: boolean;
		canBeDonePc: boolean;
		canBeDoneTablet: boolean;
	};
	startedIn: string | null;
	finishedIn: string | null;
	datetimeToFinish: string;
	customTimeFinish: boolean;
	dateTimeEndTz: string;
	forbidden: boolean;
}

export interface SubmitAnswerResponse {
	status: string;
	message?: string;
}

export interface FinishApplicationResponse {
	success: boolean;
	message: string;
	redirect?: boolean;
}

/** Resposta de POST applications/{id}/leave-tab/ (camelCase no renderer). */
export interface LeaveTabResponse {
	pk: string | number;
	eventType?: string;
	getEventTypeDisplay?: string;
	createdAt?: string;
}

/** Resposta de PATCH applications/{id}/leave-tab/{event_pk}/finish/ */
export interface FinishLeaveTabResponse {
	pk: string | number;
	end?: string;
}
